import { Component, JSX, onMount } from 'solid-js'

import { A, useNavigate } from '@solidjs/router'
import { CheckFillIcon, MessageIcon } from 'icons'
import { isAdmin } from '../users/corp/shared'
import './style/index.scss'

const Extentions: Component = () => {
    let nav = useNavigate()

    onMount(() => {
        if (!isAdmin()) return nav('/panel/403', { replace: true })
    })

    interface PickCmpProps {
        icon: JSX.Element
        holder: string
        sub: string

        link: string

        class?: string
    }
    const PickCmp: Component<PickCmpProps> = C => {
        return (
            <A
                href={C.link}
                inactiveClass=''
                class={`pick-option ${C.class || ''}`}
            >
                <div class='icon'>{C.icon}</div>
                <div class='value title_hero2'>{C.holder}</div>
                <p class='holder title_smaller'>{C.sub}</p>
            </A>
        )
    }

    return (
        <div class='extentions-pick section'>
            <div class='picker-container'>
                <div class='pick-header title_hero'>
                    بخش مورد نظر خود را انتخاب کنید
                </div>
                <div class='pick-options'>
                    <PickCmp
                        holder='درخواست ها'
                        sub='درخواست های رسیدگی نشده'
                        link='requests/'
                        icon={<MessageIcon />}
                    />
                    <PickCmp
                        holder='الحاقیه ها'
                        sub='بیمه های اصلاح شده'
                        class='green'
                        link='submitteds/'
                        icon={<CheckFillIcon />}
                    />
                </div>
            </div>
        </div>
    )
}

export default Extentions
